// removed by extract-text-webpack-plugin
module.exports = {"container":"_3UHlop6NSx0dhk9GIRxa53","title":"_3ZpcHfBnWG01BIM4o2YUqr","error":"_2pRi9R76QKOj2u-AtLVP8b","btnCancelar":"_1wbpcK2ZN1M4gL1adCsjzg"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Profile/styles.css
// module id = 2661
// module chunks = 0